import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives';

export const MainContentHeaders = ({ children }: { children: React.ReactNode }) => (
	<Text size="large" color="color.text.subtle" weight="semibold">
		{children}
	</Text>
);
